import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ScheduleFrequency } from "@enums/scheduleFrequency.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Machine } from "@interfaces/models/machine.interface";
import { MaintenanceSchedule } from "@interfaces/models/maintenanceSchedule.interface";
import { MachineService } from "@services/machine.service";
import { MaintenanceScheduleService } from "@services/maintenanceSchedule.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "maintenanceSchedules-id",
	styleUrls: ["maintenanceSchedules-id.css"],
	templateUrl: "maintenanceSchedules-id.html"
})
export class MaintenanceSchedulesIdAdminComponent {
	createEnabled = true;
	editEnabled = true;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	item: MaintenanceSchedule = new MaintenanceSchedule();
	itemId = "";
	itemType = "Maintenance Schedule";
	machines: Machine[] = [];
	readOnly = true;
	returnUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	scheduleFrequencies: any;
	title: string = "View " + this.itemType;

	constructor(private router: Router, private toastService: ToastService, private route: ActivatedRoute, private itemService: MaintenanceScheduleService, private machineService: MachineService) {
		this.buildButtons("view");
		this.getMachines();
		this.scheduleFrequencies = GetPropertiesFromEnum(ScheduleFrequency);

		this.route.params
			.subscribe((params) => {
				if (params.id != "create") {
					if (params.id.split("_").length > 1) {
						this.getItem(params.id.split("_")[0]);
						this.edit();
					} else {
						this.getItem(params.id);
					}
				} else {
					this.create();
				}
			});
	}

	buildButtons(mode: string) {
		if (mode == "edit" && this.editEnabled) {
			this.headerPrimaryButtons = [
				{ method: "updateItem", text: "Save Changes" },
				{ method: "cancelEditing", text: "View Mode" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "create" && this.createEnabled) {
			this.headerPrimaryButtons = [
				{ method: "createItem", text: "Save" },
				{ method: "close", text: "Close" }
			];
		} else if (mode == "view") {
			this.headerPrimaryButtons = [
				{ method: "edit", text: "Edit" },
				{ method: "close", text: "Close" }
			];	
		}
	}

	cancelEditing() {
		if (confirm("Are you sure you wish to switch modes? Unsaved changes will be discarded.") == false) {
			return;
		}
		this.readOnly = true;
		this.buildButtons("view");
		this.title = "View " + this.itemType;
	}

	close() {
		this.router.navigate([`/${this.returnUrl}/`]);
	}

	create() {
		this.readOnly = false;
		this.buildButtons("create");
		this.title = "Create New " + this.itemType;
	}

	createItem() {
		this.itemService.createSingle(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Created " + this.itemType);
					this.close();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	displayMachineInDropdown(e: any) { return e === null ? null : e.cellNumber === null ? e.name : `${e.cellNumber} - ${e.name}`; }

	edit() {
		this.readOnly = false;
		this.buildButtons("edit");
		this.title = "Edit " + this.itemType;
		this.toastService.warn("You are now editing...");
	}
	
	getItem(itemId: number) {
		this.itemService.getSingleById(itemId)
			.subscribe(
				(res: any) => {
					this.item = res.response;
				},
				(err) => {console.log(err); this.toastService.error("Something Went Wrong!");}
			);
	}

	getMachines() {
		this.machineService.getAll()
			.subscribe(
				(res: any) => {
					this.machines = res.response.items;
					this.machines.sort((a,b) => (a.cellNumber + " - " + a.name).localeCompare((b.cellNumber + " - " + b.name)));
				},
				(err) => console.log(err)
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	updateItem() {
		this.itemService.updateSingleById(this.item.id, this.item)
			.subscribe(
				() => this.toastService.success("Successfully Updated"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}
}